export default __webpack_public_path__ + "static/media/iconAddPhoto.a7366ad4.svg";